import { render } from "./OrderCreate.vue?vue&type=template&id=025e3b92&scoped=true"
import script from "./OrderCreate.vue?vue&type=script&lang=js"
export * from "./OrderCreate.vue?vue&type=script&lang=js"

import "./OrderCreate.vue?vue&type=style&index=0&id=025e3b92&scoped=true&lang=css"

import exportComponent from "/var/www/abg/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-025e3b92"]])

export default __exports__